import React, { useEffect, useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import useWindowSize from '../../../hooks/useWindowSize';
import moment from 'moment';
import { array, object } from 'prop-types';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';
import {enqueueSnackbar} from '../../../actions/applicationMessageActions';

import { orderBy } from 'lodash';

import BobLoadingMask from '../../../components/BobLoadingMask';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import BobActionMenu from '../../../components/BobActionMenu';
import * as BasAgentActions from '../../../actions/basAgentActions';
import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import { fetchWatchDogReports, fetchReportData } from '../../../actions/reportingActions';
import DeleteReportModal from './DeleteReportModal';
import ReportPreviewModal from './ReportPreviewModal';
import ReportsViewSelector from './ReportsViewSelector';
import classes from './Table.module.css';
import { getTimeZoneAbbr } from '../../../helpers/timezones';
import { calculateMinColumnWidths } from '../../../helpers/calculateMinColumnWidths';
import PreviewWatchDogReportModal from './PreviewWatchDogReportModal';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';

const initialDataState = {
    sort:   [],
    filter: [],
    take:   10,
    skip:   0
};

const ReportList = ({
    activeNavCompany,
    basAgentsReport,
    bobLoading,
    clearBasAgentsReport,
    createCustomerSupportReport,
    companyInfo,
    fetchBasAgentsReport,
    fetchInspectionReports,
    fetchReportData,
    fetchWatchDogReports,
    deleteInspectionReport,
    targetNavCompany,
    setCreateMode,
    createMode,
    history,
    inspectionReports,
    currentUser,
    selectedView,
    setSelectedView,
    setWorkBookMode,
    watchDogReports,
    workbookModeEnabled,
    ...props
}) => {

    const [inspectionReportList, setinspectionReportList] = useState([]);
    const [watchDogReportList, setWatchDogReportList] = useState([]);
    const [take, setTake] = useState(10);
    const [pageable] = useState({ pageSizes: true });
    const [deleteModal, setDeleteModal] = useState(false);
    const [currentReport, setcurrentReport] = useState(null);
    const [showMsg, setShowMsg] = useState(false);
    const [dataState, setDataState] = useState(initialDataState);
    const [watchDogDataState, setWatchDogDataState] = useState(initialDataState);
    const [siteColumnWidth, setSiteColumnWidth] = useState(350);
    const [showWatchDogReport, setShowWatchDogReport] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useDispatch();
    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const columns = gridRef.current.props.children;
        setSiteColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'siteName', 350, true));
    }, [windowSize]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setDataState(initialDataState);
            setWatchDogDataState(initialDataState);
        }
    }, [workbookModeEnabled]);

    useEffect(() => {
        const init = async () => {
            await Promise.all([fetchInspectionReports(activeNavCompany.id), fetchWatchDogReports()].map(p => p.catch(err => err)));
        };

        if (activeNavCompany && activeNavCompany.id) init();
    }, [activeNavCompany]);


    useEffect(() => {
        setinspectionReportList(inspectionReports);
    }, [inspectionReports]);

    useEffect(() => {
        setWatchDogReportList(orderBy(watchDogReports, ['timestamp'], ['desc']));
    }, [watchDogReports]);

    const handleDelete = () => {
        const init = async () => {
            let _delete =  await deleteInspectionReport(currentReport.processId, currentReport.groupId,targetNavCompany.id);
            handleClose();
            if (_delete) {
                if (selectedView === 'Inspection Reports') {
                    await fetchInspectionReports(targetNavCompany.id);
                } else if (selectedView === 'Watchdog Reports') {
                    await fetchWatchDogReports();
                }
            }
        };

        if (targetNavCompany && targetNavCompany.id) init();
    };

    const handleClose = () => {
        setShowMsg(false);
    };

    const handleCloseDeleteModal = (announcement) => {
        setDeleteModal(false);
    };

    const fetchUserData = (requestData, actionType, processId) => {
        switch (actionType) {
            case 'delete':
                handleReportDelete(requestData);
                break;
            case 'select':
                if (selectedView === 'Inspection Reports') {
                    handleReportPreview(processId);
                } else if (selectedView === 'Watchdog Reports') {
                    handleWatchDogReportPreview(processId, requestData);
                }
                break;
            default:
                break;
        }
    };

    const actionsCell = props => {
        const processId = props.dataItem.processId;

        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu
                    type="Reporting"
                    entityData={props.dataItem}
                    onFetch={(requestData, actionType) => fetchUserData(requestData, actionType, processId)}
                />
            </td>
        );
    };

    const handleReportDelete = (report) => {
        setcurrentReport(report);
        setDeleteModal(true);
    };

    const handleReportPreview = async (processId) => {
        const reportData = await fetchReportData(activeNavCompany.id, processId, 'InspectionReportDataExport');
        if (reportData) {
            const reportTimestamp = inspectionReportList.find(r => r.processId === processId).timestamp;
            reportData.timestamp = reportTimestamp;
            setcurrentReport(reportData);
            setShowMsg(true);
        }
        else {
            dispatch(enqueueSnackbar('Unable to retrieve report data', 'error'));
        }
    };

    const handleWatchDogReportPreview = async (processId, dataItem) => {
        const reportData = await fetchReportData(activeNavCompany.id, processId, 'WatchdogReport');
        setcurrentReport({ ...reportData, targetDateEnd: dataItem.targetDateEnd, targetDateStart: dataItem.targetDateStart });
        setShowWatchDogReport(true);
    };

    const startDateCell = (props) => {
        let rowData = props.dataItem;

        const zone = moment.tz.guess();
        const displayDate = rowData && rowData.targetStart ? moment(new Date(rowData.targetStart).toISOString()).format('YYYY-MM-DD hh:mm A') + ' ' + getTimeZoneAbbr(moment(rowData.targetStart), zone) : null;

        return (
            <td className={props.className} style={props.style}>{displayDate}</td>
        );
    };

    const endDateCell = (props) => {
        let rowData = props.dataItem;
        const zone = moment.tz.guess();
        const displayDate = rowData && rowData.targetEnd ? moment(new Date(rowData.targetEnd).toISOString()).format('YYYY-MM-DD hh:mm A') + ' ' + getTimeZoneAbbr(moment(rowData.targetEnd), zone) : null;

        return (
            <td className={props.className} style={props.style}>{displayDate}</td>
        );
    };

    const generatedCell = (props) => {
        let rowData = props.dataItem;
        const zone = moment.tz.guess();
        const displayDate = rowData && rowData ? moment(rowData.timestamp).format('YYYY-MM-DD hh:mm A') + ' ' + getTimeZoneAbbr(moment(rowData.timestamp), zone) : null;

        return (
            <td className={props.className} style={props.style}>{displayDate}</td>
        );
    };

    const refreshGrid = () => {
        const refresh = async () => {
            if (selectedView === 'Inspection Reports') {
                await fetchInspectionReports(targetNavCompany.id);
                setinspectionReportList(inspectionReports);
            } else if (selectedView === 'Watchdog Reports') {
                setIsLoading(true);
                await fetchWatchDogReports();
                setWatchDogReportList(watchDogReports);
                setIsLoading(false);
            }
        };

        if (targetNavCompany && targetNavCompany.id) refresh();
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    const onWatchDogDataStateChange = e => {
        setTake(e.dataState.take);
        setWatchDogDataState(e.dataState);
    };

    const renderWatchDogStartTime = props => {
        const zone = moment.tz.guess();

        return (
            <td className={props.className} style={props.style}>{moment(props.dataItem.targetDateStart).format('YYYY-MM-DD hh:mm A') + ' ' + getTimeZoneAbbr(moment(props.dataItem.targetDateStart), zone)}</td>
        );
    };

    const renderWatchDogEndTime = props => {
        const zone = moment.tz.guess();

        return (
            <td className={props.className} style={props.style}>{moment(props.dataItem.targetDateEnd).format('YYYY-MM-DD hh:mm A') + ' ' + getTimeZoneAbbr(moment(props.dataItem.targetDateEnd), zone)}</td>
        );
    };

    return (
        <div ref={gridDivRef} className={`announcement-table ${classes.Table}`}>
            <div className={classes.TableContainerHead}>
                <div className={classes.SelectorContainer}>
                    <ReportsViewSelector
                        handleChangeView={setSelectedView}
                        view={selectedView}
                    />
                </div>
                <div className={classes.WorkbookModeContainer}>
                    <BobWorkbookModeButton
                        handleWorkbookMode={handleWorkbookMode}
                        workbookMode={workbookModeEnabled}
                    />
                </div>
                <div
                    className={classes.RefreshContainer}
                    aria-hidden="true"
                    role="button"
                    tabIndex={0}
                    onClick={refreshGrid}
                >
                    <span className="material-icons-outlined">refresh</span>
                </div>
                <div className={classes.ActionButtonContainer}>
                    <BobActionMenu
                        type="Reporting"
                        deleteFl={false}
                        handleCreateReport={() => setCreateMode(!createMode)}
                        isSuperAdmin={currentUser.isSuperUser || currentUser.email?.trimEnd().endsWith('@key2act.com')}
                    />
                </div>

            </div>
            {
                selectedView === 'Inspection Reports' ?
                    <React.Fragment>
                        <style>
                            { kendoGridInlineStyling }
                        </style>
                        <Grid
                            ref={gridRef}
                            className={classes.KendoGrid}
                            data={inspectionReportList ? kendoProcess(inspectionReportList, dataState) : []}
                            {...dataState}
                            filterable={workbookModeEnabled}
                            sortable={{
                                mode: 'multiple'
                            }}
                            pageable={pageable}
                            reorderable
                            onDataStateChange={onDataStateChange}
                        >
                            <Column
                                title="Target Site"
                                width={siteColumnWidth}
                                field="siteName"
                            />
                            <Column
                                title="Target Client"
                                width="350px"
                                field="clientName"
                            />
                            <Column
                                title="Start Date"
                                width="300px"
                                field="targetDateStart"
                                cell={startDateCell}
                                filter={'date'}
                            />
                            <Column
                                title="End Date"
                                field="targetDateEnd"
                                width="300px"
                                cell={endDateCell}
                                filter={'date'}
                            />
                            <Column
                                title="Generated"
                                field="timestamp"
                                width="300px"
                                cell={generatedCell}
                                filter={'date'}
                            />
                            <Column
                                field=""
                                title=""
                                width="80px"
                                locked={true}
                                sortable={false}
                                filterable={false}
                                cell={actionsCell}
                            />
                        </Grid>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <style>
                            {
                                `.k-textbox {
                        font-size: 1.2rem;
                    }
                    .k-numerictextbox {
                        font-size: 1.2rem;
                    }
                    .k-dropdown {
                        font-size: 1.2rem;
                    }
                    .k-dateinput {
                        font-size: 1.2rem;
                    }
                    `
                            }
                        </style>
                        <Grid
                            ref={gridRef}
                            className={classes.KendoGrid}
                            data={watchDogReportList ? kendoProcess(watchDogReportList, watchDogDataState) : []}
                            {...watchDogDataState}
                            filterable={workbookModeEnabled}
                            sortable={{
                                mode: 'multiple'
                            }}
                            pageable={pageable}
                            reorderable
                            onDataStateChange={onWatchDogDataStateChange}
                        >
                            <Column
                                title="Target Client"
                                width={'350px'}
                                field="clientName"
                            />
                            <Column
                                title="Target Site"
                                width={siteColumnWidth}
                                field="siteName"
                            />
                            <Column
                                title="Start Date"
                                width="300px"
                                field="targetDateStart"
                                cell={renderWatchDogStartTime}
                                filter={'date'}
                            />
                            <Column
                                title="End Date"
                                field="targetDateEnd"
                                cell={renderWatchDogEndTime}
                                width="300px"
                                filter={'date'}
                            />
                            <Column
                                title="Generated"
                                field="timestamp"
                                width="300px"
                                cell={generatedCell}
                                filter={'date'}
                            />
                            <Column
                                field=""
                                title=""
                                width="80px"
                                locked={true}
                                sortable={false}
                                filterable={false}
                                cell={actionsCell}
                            />
                        </Grid>
                    </React.Fragment>
            }
            {deleteModal ?
                <DeleteReportModal
                    open={deleteModal}
                    close={(report) => handleCloseDeleteModal(report)}
                    handleDelete={handleDelete}
                    message={`Are you sure you want to delete this report?`}
                    title={`Confirm Delete: Report`}
                />
                : ''}
            {
                bobLoading.includes('Reporting') || isLoading ?
                    <BobLoadingMask
                        className={classes.Loader}
                    />
                    :
                    null
            }
            { showMsg?
                <ReportPreviewModal
                    title={currentReport.title}
                    targetReport={currentReport}
                    open={showMsg}
                    close={handleClose}
                />:''
            }
            {
                showWatchDogReport ?
                    <PreviewWatchDogReportModal
                        title={'Watchdog Report'}
                        targetReport={currentReport}
                        open={showWatchDogReport}
                        close={() => setShowWatchDogReport(false)}
                    />
                    :
                    null
            }
        </div>
    );
};

ReportList.defaultProps = {
    announcementList: [],
    currentUser:      {}
};

ReportList.propTypes = {
    announcementList: array,
    currentUser:      object
};

const mapStateToProps = state => ({
    activeNavCompany:    state.bob.activeNavCompany,
    targetNavCompany:    state.bob.targetNavCompany,
    basAgentsReport:     state.basAgent.basAgentsReport,
    bobLoading:          state.bob.bobLoading,
    companyInfo:         state.companyInfo,
    inspectionReports:   state.dashboard.inspectionReports,
    currentUser:         state.currentUser,
    watchDogReports:     state.reporting.watchDogReports,
    workbookModeEnabled: state.dashboard.workbookModeEnabled
});

const mapDispatchToProps = ({
    ...BasAgentActions,
    ...BobActions,
    ...DashboardActions,
    fetchWatchDogReports,
    fetchReportData
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportList));
